/**
 * TosConsentCard.module.scss — narcis's token contribution to the shared `core/consent/TosConsentCard`
 * (plan 2026_09_01_tos_gate.md §8.5). Was TosConfirmCard.module.scss; renamed with its former card,
 * minus the button rules the shared card doesn't have — the second press is the surface's own CTA
 * now, not a button inside this card. Each render site supplies its own show/hide wrapper.
 */

@import '@styles/fonts.scss';
@import '@styles/colors.scss';

.card {
    display: flex;
    flex-direction: column;
    gap: 11px;
    border: 1px solid var(--yolk-med);
    background: var(--surface);
    border-radius: var(--radius-md, 10px);
    padding: 14px;
}

.title {
    font-family: var(--font-display);
    font-style: italic;
    font-weight: 500;
    font-size: 17px;
    color: var(--text);
}

.sub {
    font-size: 12px;
    color: var(--text-muted);
    margin-top: 1px;
}

.checkbox {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    cursor: pointer;
    font-size: 12.5px;
    color: var(--text-muted);
    line-height: 1.5;
    text-align: left;

    input[type='checkbox'] {
        margin-top: 3px;
        width: 15px;
        height: 15px;
        flex-shrink: 0;
        accent-color: var(--yolk);
        cursor: pointer;
    }

    a {
        color: var(--yolk);
        text-decoration: none;
        font-weight: 500;

        &:hover {
            text-decoration: underline;
        }
    }
}
